import { render, staticRenderFns } from "./ModalPosition.vue?vue&type=template&id=8cd951ba&scoped=true"
import script from "./ModalPosition.vue?vue&type=script&lang=js"
export * from "./ModalPosition.vue?vue&type=script&lang=js"
import style0 from "./ModalPosition.vue?vue&type=style&index=0&id=8cd951ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cd951ba",
  null
  
)

export default component.exports